module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "alsoby"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }), _c('div', {
    staticClass: "title-alsoby"
  }, [_vm._v("Books by Elizabeth Beverly")]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Silhouette Desire")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("An Unsuitable Man for the Job")]), _vm._v(" #724 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Jake’s Christmas")]), _vm._v(" #753 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("A Lawless Man")]), _vm._v(" #856 "), _c('br'), _vm._v("*"), _c('em', {
    staticClass: "i"
  }, [_vm._v("A Dad Like Daniel")]), _vm._v(" #908 "), _c('br'), _vm._v("*"), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Perfect Father")]), _vm._v(" #920 "), _c('br'), _vm._v("*"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dr. Daddy")]), _vm._v(" #933 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("†")]), _c('em', {
    staticClass: "i"
  }, [_vm._v("Father of the Brat")]), _vm._v(" #993 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("†")]), _c('em', {
    staticClass: "i"
  }, [_vm._v("Father of the Brood")]), _vm._v(" #1005 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("†")]), _c('em', {
    staticClass: "i"
  }, [_vm._v("Father on the Brink")]), _vm._v(" #1016 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("*")]), _c('em', {
    staticClass: "i"
  }, [_vm._v("Roxy and the Rich Man")]), _vm._v(" #1053 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("*")]), _c('em', {
    staticClass: "i"
  }, [_vm._v("Lucy and the Loner")]), _vm._v(" #1063")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br"
  }, [_c('span', [_vm._v("*From Here to Maternity "), _c('br'), _vm._v("†From Here to Paternity "), _c('br'), _vm._v("‡The Family McCormick")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Silhouette Special Edition")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Destinations South")]), _vm._v(" #557 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Close Range")]), _vm._v(" #590 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Donovan’s Chance")]), _vm._v(" #639 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Moriah’s Mutiny")]), _vm._v(" #676 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Up Close")]), _vm._v(" #737 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Hired Hand")]), _vm._v(" #803 "), _c('br'), _c('em', {
    staticClass: "i"
  }, [_vm._v("Return Engagement")]), _vm._v(" #844")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f685e74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459271517_als01.vue
// module id = 69
// module chunks = 0